import styled from 'styled-components';

export const StyledSaleEventStartCardContainer = styled.div`
  height: 100%;
  width: 100%;
  border-radius: 3px 0 0 3px;
  border-left: 6px solid blue;
  background-color: ${({ theme }) => theme.COLORS.BASE};
`;

export const StyledSaleEventStartCard = styled.div`
  height: 100%;
  width: 100%;
  padding: 18px 12px;
  border-top: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
`;

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;

export const StyledDealerEvent = styled.div`
  height: 32px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const StyledVehiclesTotal = styled.div`
  width: 102px;
  text-align: right;
  text-transform: capitalize;
`;

export const StyledEventName = styled.div`
  height: 40px;
  width: 100%;
  margin-top: 14px;
  font-size: 20px;
  line-height: 20px;
  overflow: hidden;
`;

export const StyledContent = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;

export const StyledHostedBy = styled.div`
  margin-top: 18px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const StyledDealerGroup = styled.div`
  height: 36px;
  overflow: hidden;
  line-height: 18px;
  display: flex;
  align-items: flex-start;
  margin-top: 6px;
`;

export const StyledSellerBadge = styled.div`
  margin-top: 4px;
`;

export const StyledDealerGroupName = styled.div``;

export const StyledActive = styled.div`
  margin-top: 21px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const StyledLaunchTime = styled.div`
  margin-top: 6px;
`;
